export const ORG_APPLY_URL = "/organisation/apply";

export const ORG_SIGNIN_URL = "https://privacy360.io/auth";

export const ORG_APPLY_LABEL = "Apply for an account";

export const ORG_APPLY_HELPER_COPY =
  "Applications are reviewed by our team; we’ll confirm your plan and issue your contract before your account goes live.";
